// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"e7b32ed0","903":"a3888e7e"}[chunkId] + ".chunk.js";
};